import { render, staticRenderFns } from "./DisplayEmployeeOnlyAvatar.vue?vue&type=template&id=d25c4dd2&scoped=true"
import script from "./DisplayEmployeeOnlyAvatar.vue?vue&type=script&lang=js"
export * from "./DisplayEmployeeOnlyAvatar.vue?vue&type=script&lang=js"
import style0 from "./DisplayEmployeeOnlyAvatar.vue?vue&type=style&index=0&id=d25c4dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25c4dd2",
  null
  
)

export default component.exports